import React from 'react';
import { Button } from 'reactstrap';
import { ModalButtonSave, ModalButtonUpdate } from '../../constant';
import { FormTransports } from './FormTransports';
// import { DeleteTransports } from './DeleteTransports';
import { Dialog } from 'primereact/dialog';

export const ModalTransports = (props) => {

    const {
        modal, modalTitle, closeDialog, method,
        loading, validaciones,
        name, abbreviation, code, handleInputChange,
        saveCreate, saveUpdate,
    } = props;


    const footer = (
        <div
            className='mt-2'
            style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px"
            }}
        >
            <Button
                color="danger"
                size="sm"
                onClick={closeDialog}
                disabled={loading}
            >
                Cancelar
            </Button>

            <Button
                color="primary"
                size="sm"
                onClick={method === "create" ? saveCreate : saveUpdate}
                disabled={loading}
                className={loading ? "progress-bar-animated progress-bar-striped" : ""}
            >
                {
                    loading
                        ? (
                            <>
                                <i className="fa fa-spinner fa-spin mr-2"></i>
                                Guardando...
                            </>
                        )
                        : "Confirmar"
                }
            </Button>
        </div>
    );


    return (
        <Dialog 
            header={modalTitle} 
            visible={modal} 
            onHide={closeDialog} 
            closable 
            modal 
            blockScroll 
            className='medium-dialog'
            footer={footer}
        >
            {
                method === "create"
                    ? <FormTransports
                        button={ModalButtonSave}
                        {...{ loading, handleInputChange, validaciones, methodAction: saveCreate }}
                    />
                    : (method === "update")
                        ?
                        <FormTransports
                            button={ModalButtonUpdate}
                            {...{ loading, handleInputChange, validaciones, methodAction: saveUpdate, name, abbreviation, code }} />
                        :
                        null
            }
        </Dialog>
    )
}
